import { useRouter } from '@uirouter/react';

import { LoadingButton } from '@@/buttons/LoadingButton';
import { Button } from '@@/buttons';
import { SheetClose, SheetFooter } from '@@/Sheet';

interface Props {
  isEditing: boolean;
  isLoading: boolean;
  disabled: boolean;
  /** Puts the actions in the drawer footer, with a cancel button that closes the drawer */
  inDrawer?: boolean;
}

export function CredentialsFormActions({
  isEditing,
  isLoading,
  disabled,
  inDrawer,
}: Props) {
  const router = useRouter();

  const saveButton = (
    <LoadingButton
      disabled={disabled}
      data-cy="createCredentials-saveButton"
      isLoading={isLoading}
      className="!ml-0"
      loadingText="Saving credentials..."
    >
      {isEditing ? 'Update credentials' : 'Add credentials'}
    </LoadingButton>
  );

  if (inDrawer) {
    return (
      <SheetFooter>
        <SheetClose asChild>
          <Button color="default" data-cy="createCredentials-cancelButton">
            Cancel
          </Button>
        </SheetClose>
        {saveButton}
      </SheetFooter>
    );
  }

  return (
    <div className="form-group">
      <div className="col-sm-12 mt-3">
        {saveButton}
        {isEditing && (
          <Button
            color="default"
            data-cy="createCredentials-cancelButton"
            onClick={() =>
              router.stateService.go('portainer.settings.sharedcredentials')
            }
          >
            Cancel
          </Button>
        )}
      </div>
    </div>
  );
}
